<common-header [title]="titlePage" [items]="items"></common-header>
<app-general-edit-egm [isEditParameters]="true"></app-general-edit-egm>
